import { render, staticRenderFns } from "./orderCardItem.vue?vue&type=template&id=6f79926f&"
import script from "./orderCardItem.vue?vue&type=script&lang=js&"
export * from "./orderCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports